import React, { useState } from "react";
import ro from "/src/content/ro.json";

const GdprRequest = () => {
  const [email, setEmail] = useState("");
  const [type, setType] = useState("delete");
  const [sent, setSent] = useState(false);
  const content = ro.legal.gdpr;

  const handleSubmit = (e) => {
    e.preventDefault();

    window.location.href = `mailto:${ro.legal.privacy.section1.email}?subject=${encodeURIComponent(
      `${content.subjectPrefix} (${type})`
    )}&body=${encodeURIComponent(
      `${content.bodyEmailLabel} ${email}\r\n${content.bodyRequestLabel} ${type}`
    )}`;

    setSent(true);
  };

  return (
    <div
      className="max-w-xl mx-auto px-6 py-12"
      style={{ backgroundColor: "var(--color-bg)", color: "var(--color-text)" }}
    >
      <h1 className="text-3xl font-bold text-orange-500 mb-6">
        {content.title}
      </h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block mb-2">{content.emailLabel}</label>
          <input
            type="email"
            required
            className="w-full p-3 rounded-lg border"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div>
          <label className="block mb-2">{content.typeLabel}</label>
          <select
            className="w-full p-3 rounded-lg border themed-select"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="delete">{content.typeDelete}</option>
            <option value="export">{content.typeExport}</option>
          </select>
        </div>

        <button className="w-full bg-orange-500 text-white py-3 rounded-lg font-semibold">
          {content.submit}
        </button>

        {sent && (
          <p className="text-green-500 text-center mt-4">{content.success}</p>
        )}
      </form>
    </div>
  );
};

export default GdprRequest;
